





































import { Component, Prop, Vue } from 'vue-property-decorator';

import MmStatusBadge from '../../components/MmStatusBadge.vue';
import { MM_EMPTY_DASH, formatDateTime } from '../../core/format';
import { MmMonitoringBatch } from './batch';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.results.';

@Component({
	components: { MmStatusBadge },
})
export default class MonitoringMeta extends Vue {
	@Prop({ default: null }) readonly batch!: MmMonitoringBatch | null;

	get dash(): string {
		return MM_EMPTY_DASH;
	}

	get titleText(): string {
		return this.$t(KEY_PREFIX + 'metaTitle') as string;
	}

	get labelCreated(): string {
		return this.$t(KEY_PREFIX + 'summaryCreated') as string;
	}

	get labelType(): string {
		return this.$t(KEY_PREFIX + 'summaryType') as string;
	}

	get labelZone(): string {
		return this.$t(KEY_PREFIX + 'summaryZone') as string;
	}

	get labelCompetitors(): string {
		return this.$t(KEY_PREFIX + 'summaryCompetitors') as string;
	}

	get approxHintText(): string {
		return this.$t(KEY_PREFIX + 'monitoringApproxHint') as string;
	}

	get createdText(): string {
		return this.batch === null ? MM_EMPTY_DASH : formatDateTime(this.batch.createdAt);
	}

	get typeValue(): string {
		if (this.batch === null || this.batch.type === null) {
			return '';
		}

		return String(this.batch.type);
	}

	get zoneText(): string {
		if (this.batch === null) {
			return MM_EMPTY_DASH;
		}

		const parts: string[] = [];
		const names: (string | null)[] = [
			this.batch.storeFormatName,
			this.batch.storeRegionName,
			this.batch.storeClusterName,
		];

		for (let i = 0; i < names.length; i += 1) {
			const name = names[i];

			if (name !== null && name !== undefined && String(name).trim() !== '') {
				parts.push(String(name).trim());
			}
		}

		return parts.length === 0 ? MM_EMPTY_DASH : parts.join(' · ');
	}

	get competitorsText(): string {
		return this.batch === null ? MM_EMPTY_DASH : String(this.batch.competitorCodes.length);
	}

	get isApproximate(): boolean {
		return this.batch !== null && this.batch.isApproximate;
	}
}
